import Highcharts from 'highcharts';

export const figure37 = { 
    chart: {
        reversed: true,
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },

    exporting: {
        enabled: false
    },

    xAxis: {
        categories: [
            1970,
            1974,
            1978,
            1979,
            1981,
            1983,
            1985,
            1987,
            1989,
            1990,
            1992,
            1995,
            1997,
            2000,
            2004,
            2006,
            2008,
            2009,
            2011,
            2013,
            2015,
            2017,
            2020
        ],
        // min: 1970,
        // max: 2020,
        // tickInterval : 10,
        gridLineWidth: 2,
        crosshair: {
            width: 1,
            color: '#4472c4'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        // tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    },

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 100,
        min: 0,
        tickInterval: 10,
        title: {
            text: "%",
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                enabled: false
            }
        }
    },
    series: [ {
        name: 'Proporción de poblaciones de peces cuyos niveles son biológicamente sostenibles en todo el mundo',
        type: 'line',
        color: '#5b9bd5',
        zoneAxis: 'x',
        dataLabels: {
            enabled: false,
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }

        },

        data: [null, 90,91.46341463,86.98224852,86.41975309, 83.33333333,81.81818182,75.67567568,73.36956522,81.86813187,76.77725118,74.32432432,76.96629213,72.79069767,76.39484979,72.37113402,67.0212766,69.55380577,71.07843137,68,66.66666667,65.8490566, null],
    }],


};
